(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('bbpsMarkupDetails', {
            parent: 'account',
            url: '/bbps-markup-details',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/entities/bbps-markup-details/bbps-markup-details.html',
                    controller: 'bbpsMarkupDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        })

                
    }
})();